"use strict";
/**
 * @file Deprecated: For implementing V2 routes, use the @genoa/state-management API module instead at
 * packages/state-management/src/modules/api
 * @deprecated
 */
exports.__esModule = true;
exports.setCookieConsents = exports.getCookieConsents = exports.getPaymentScheduleV2Route = exports.billPayNowV2Route = exports.billPayNowSubmitV2Route = exports.setupCardV2Route = exports.getCardsV2Route = exports.addCardV2Route = exports.addFundsRoute = exports.walletBalanceRoute = exports.withdrawFundsRoute = exports.getAgreementsRoute = exports.useSwitchSelfpayVCRoute = exports.useGetDdaDecisionsRoute = exports.getTermsAcceptLinkRoute = void 0;
var BASE_URL = 'v2/orchestration';
function getTermsAcceptLinkRoute(customerId) {
    return "".concat(BASE_URL, "/").concat(customerId, "/account/terms/tokenized-accept");
}
exports.getTermsAcceptLinkRoute = getTermsAcceptLinkRoute;
var useGetDdaDecisionsRoute = function (customerPublicId, billTransactionId, queryDate) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/bill/dda-decisions?bill_transaction_id=").concat(billTransactionId, "&query_date=").concat(queryDate);
};
exports.useGetDdaDecisionsRoute = useGetDdaDecisionsRoute;
var useSwitchSelfpayVCRoute = function (customerPublicId, billTransactionId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/bill/switch-selfpay?bill_transaction_id=").concat(billTransactionId);
};
exports.useSwitchSelfpayVCRoute = useSwitchSelfpayVCRoute;
function getAgreementsRoute(customerId, agreementTypes, onlyFinancialPartnerSpecific) {
    return "".concat(BASE_URL, "/").concat(customerId, "/account/agreements?agreement_types=").concat(agreementTypes.join(), "&only_financial_partner_specific=").concat(onlyFinancialPartnerSpecific);
}
exports.getAgreementsRoute = getAgreementsRoute;
var withdrawFundsRoute = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/funds/withdraw");
};
exports.withdrawFundsRoute = withdrawFundsRoute;
var walletBalanceRoute = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/balance");
};
exports.walletBalanceRoute = walletBalanceRoute;
var addFundsRoute = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/funds/add");
};
exports.addFundsRoute = addFundsRoute;
var addCardV2Route = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/cards/add");
};
exports.addCardV2Route = addCardV2Route;
var getCardsV2Route = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/cards");
};
exports.getCardsV2Route = getCardsV2Route;
var setupCardV2Route = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/wallet/cards/setup");
};
exports.setupCardV2Route = setupCardV2Route;
var billPayNowSubmitV2Route = function (customerPublicId) {
    return "".concat(BASE_URL).concat(customerPublicId ? "/".concat(customerPublicId) : '', "/pay-now/submit");
};
exports.billPayNowSubmitV2Route = billPayNowSubmitV2Route;
var billPayNowV2Route = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/pay-now");
};
exports.billPayNowV2Route = billPayNowV2Route;
var getPaymentScheduleV2Route = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/payment-schedule");
};
exports.getPaymentScheduleV2Route = getPaymentScheduleV2Route;
var getCookieConsents = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/account/customer-cookie-consents");
};
exports.getCookieConsents = getCookieConsents;
var setCookieConsents = function (customerPublicId) {
    return "".concat(BASE_URL, "/").concat(customerPublicId, "/account/customer-cookie-consents/store");
};
exports.setCookieConsents = setCookieConsents;
